export default {
  headerContent: {
    title: 'HDI Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Nakliyat (Emtea) Sigortası Nedir?',
    description: {
      title: 'HDI Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'HDI Sigorta nakliyat sigortası ürünü ile kişi veya kurumların yurt içi veya yurt dışı nakliyelerini koruma altına almaktadır.',
        'HDI Sigorta nakliyat sigortası, yükün sevkiyatı sırasında oluşabilecek doğal afet, yangın ve su hasarlarına karşı güvence sağlayarak sigortalının bütçesini korumasında destek almaktadır.'
      ]
    },
    subContent: {
      title: 'HDI Sigorta Nakliyat Sigortası Türleri Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasında düzenlenmekte olan 4 adet poliçe çeşidi bulunmaktadır.',
          subList: [
            'Kati Poliçe',
            'Flotan Poliçe(Geçici)',
            'Abonman Poliçe',
            'Blok Poliçe'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Nakliyat Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Nakliyat Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
